import { SplunkIconUrl } from "@p0security/shared/integrations/constants";
import { SplunkComponents } from "@p0security/shared/integrations/event-collectors/splunk/components";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { Logo } from "../Logo";
import { splunkInstaller } from "./install";

export const SplunkIcon = (
  <Logo logo={SplunkIconUrl} title="Splunk" size={14} />
);
export const Splunk = (
  props: Pick<
    InstallProps<typeof SplunkComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "token", []);
  return (
    <Install<typeof SplunkComponents>
      components={SplunkComponents}
      installer={splunkInstaller}
      integration="splunk"
      itemKind={itemKind}
      logo={SplunkIconUrl}
      title={"Splunk"}
      {...props}
    />
  );
};
